module.exports = new __parcel__URL__("testimonial-george-mobile.ba4357c1.webp").toString();